import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import {
  loadAllJobsByParams,
  loadDashboardReports,
  loadDashboardReportsOffer,
  loadDashboardReportsSubmissions,
  loadJobFunctions,
  loadAveragesPerJob,
} from '@modules/reports/store/referral-reports.actions';
import { JobsPageFilterType } from '@modules/jobs-page/store/filter/filter.reducer';
import { Subpages } from '@modules/reports/models/subpages';
import { DEFAULT_JOB_STATUS_FILTER } from '@shared/models/job-statuses';
import { ReferralReportsFilters } from '@modules/reports/models/referral-reports-filters';
import {
  allDepartments,
  allFunctions,
} from '@modules/reports/models/all-functions-and-departments';

@Injectable()
export class DashboardPageResolver {
  filters: ReferralReportsFilters = {
    jobDepartment: allDepartments,
    jobFunction: allFunctions,
    jobStatus: DEFAULT_JOB_STATUS_FILTER,
  };

  constructor(private store: Store<{}>) {}

  resolve(route: ActivatedRouteSnapshot): Observable<void> | void {
    this.store.dispatch(
      loadAllJobsByParams({
        params: { jobAssignedTo: JobsPageFilterType.ALL, offset: 0 },
      }),
    );

    this.store.dispatch(loadDashboardReports({ filters: this.filters }));
    this.store.dispatch(loadDashboardReportsSubmissions({ filters: this.filters }));
    this.store.dispatch(loadDashboardReportsOffer({ filters: this.filters }));

    this.store.dispatch(
      loadJobFunctions({
        filters: { jobStatus: DEFAULT_JOB_STATUS_FILTER },
        functionsPage: Subpages.PIPELINE,
      }),
    );

    this.store.dispatch(loadAveragesPerJob({ params: { jobStatus: DEFAULT_JOB_STATUS_FILTER } }));
  }
}
